@switch (columnName) {
  @case ('location') {
    <app-text-overflow-label [text]="form?.menu?.value?.path ?? ''"></app-text-overflow-label>
  }
  @case ('edit') {
    <button mat-button (click)="buttonFunctions.edit()">
      <mat-icon>edit</mat-icon>
    </button>
  }
  @case ('delete') {
    <button mat-button (click)="buttonFunctions.delete()">
      <mat-icon>delete</mat-icon>
    </button>
  }
  @case ('quantityType') {
    {{ form?.quantityType?.value?.name }}
  }
  @case ('quantity') {
    {{ form?.quantity?.value }} {{ form?.quantityType?.value?.name }}
  }
  @default {
    <div class="fixed-width">
      <p [title]="form.get(columnName)?.value">{{ form.get(columnName)?.value }}</p>
    </div>
  }
}
